import { InjectionToken } from '@angular/core';
import { CompaniesPort } from './companies.port';

export const COMPANIES_PORT = new InjectionToken<CompaniesPort>('COMPANIES_PORT');
